import React from 'react'
import { Switch, Route } from '@fs/zion-router'
import { LayoutBand, Grid, colors, Card, Bleed, useContainerWidth } from '@fs/zion-ui'
import { usePageView } from '@fs/zion-analytics'
import EditorHandbookHeader from './components/EditorHandbookHeader'
import EditorHandbookNav from './components/EditorHandbookNav'
import EditorHandbookContent from './components/EditorHandbookContent'
import PlaceEditorTrainingPage from '../PlaceEditorTrainingPage/PlaceEditorTrainingPage'

// Markdown base filenames (language folders determined by hook)
const landingPage = 'landing_page'
const missionAndPurpose = 'mission_and_purpose'
const creatingNewEntry = 'creating_a_new_entry'
const deletingEntries = 'deleting_entries'
const faqs = 'faqs'

// Place-related fields
const certificationStatus = 'certification_status'
const placeTypes = 'place_types'
const placeNames = 'place_names'
const parents = 'parents'
const relatedPlaces = 'related_places'

// Historical information
const historicalInformation = 'historical_information'
const historicalPeriods = 'historical_periods'

// Other fields
const nativeLanguageYearsLocation = 'native_language_years_location'
const notes = 'notes'
const researchLinksCitations = 'research_links_citations'

function EditorHandbook() {
  const atWidth = useContainerWidth()
  const leftNavPanelColumns = atWidth({ default: 12, xl: 3 })
  const rightContentColumns = atWidth({ default: 12, xl: 9 })

  return (
    <div style={{ height: '100%' }}>
      <Grid gutters="xxs">
        <Card columns={12} margins="dense">
          <EditorHandbookHeader />
        </Card>
        <Card columns={leftNavPanelColumns} margins="dense">
          <Bleed top>
            <EditorHandbookNav />
          </Bleed>
        </Card>
        <Card columns={rightContentColumns} margins="dense">
          <Bleed top>
            <Switch>
              <Route exact path="/editor-handbook/">
                <EditorHandbookContent baseFilename={landingPage} />
              </Route>
              <Route exact path="/editor-handbook/mission-and-purpose/">
                <EditorHandbookContent baseFilename={missionAndPurpose} />
              </Route>
              <Route exact path="/editor-handbook/general-info/creating-new-entry/">
                <EditorHandbookContent baseFilename={creatingNewEntry} />
              </Route>
              <Route exact path="/editor-handbook/general-info/deleting-entries/">
                <EditorHandbookContent baseFilename={deletingEntries} />
              </Route>
              <Route exact path="/editor-handbook/faqs/">
                <EditorHandbookContent baseFilename={faqs} />
              </Route>
              <Route exact path="/editor-handbook/place-fields/certification-status/">
                <EditorHandbookContent baseFilename={certificationStatus} />
              </Route>
              <Route exact path="/editor-handbook/place-fields/place-types/">
                <EditorHandbookContent baseFilename={placeTypes} />
              </Route>
              <Route exact path="/editor-handbook/place-fields/place-names/">
                <EditorHandbookContent baseFilename={placeNames} />
              </Route>
              <Route exact path="/editor-handbook/place-fields/parents/">
                <EditorHandbookContent baseFilename={parents} />
              </Route>
              <Route exact path="/editor-handbook/place-fields/related-places/">
                <EditorHandbookContent baseFilename={relatedPlaces} />
              </Route>
              <Route exact path="/editor-handbook/historical/historical-information/">
                <EditorHandbookContent baseFilename={historicalInformation} />
              </Route>
              <Route exact path="/editor-handbook/historical/historical-periods/">
                <EditorHandbookContent baseFilename={historicalPeriods} />
              </Route>
              <Route exact path="/editor-handbook/other-fields/native-language-years-location/">
                <EditorHandbookContent baseFilename={nativeLanguageYearsLocation} />
              </Route>
              <Route exact path="/editor-handbook/other-fields/notes/">
                <EditorHandbookContent baseFilename={notes} />
              </Route>
              <Route exact path="/editor-handbook/other-fields/research-links-citations/">
                <EditorHandbookContent baseFilename={researchLinksCitations} />
              </Route>
            </Switch>
          </Bleed>
        </Card>
      </Grid>
    </div>
  )
}

export default function EditorHandbookPage(): JSX.Element {
  usePageView({ page_detail: 'EditorHandbook' })

  return (
    <Switch>
      <Route path="/editor-handbook/training/">
        <PlaceEditorTrainingPage />
      </Route>
      <Route path="/editor-handbook/">
        <LayoutBand
          maxWidth="xxl"
          marginY="nano"
          marginX="nano"
          style={{ height: 'calc(100vh - 70px)', background: colors.gray02 }}
        >
          <EditorHandbook />
        </LayoutBand>
      </Route>
    </Switch>
  )
}
